/**
 * 文化馆 api管理
 */
import request from '../utils/request-whg'
export default {
    /**
     * 获取本单位智能体
     * @param {String} unitId 单位id
     * @param {String} pageNo 页码
     * @param {String} pageSize 每页数量
     * @date 2026-01-14
     */
    getRobotsByUnit(params) {
        console.log(`params`, params)
        return request({
            url: '/apiNew/agent/getRobotsByUnit',
            method: 'get',
            data: params
        })
    },
}


